import React from "react";
import { connect, DispatchProp } from "react-redux";
import { Button } from "reactstrap";
import { AppState } from "../../../store";
import { setShowClosestFirst } from "../../../store/restaurantsStore";
import { showClosestFirstSelector } from "../../../store/restaurantsStore/selectors";

export default connect(mapStateToProps)(
  ({
    showClosestFirst,
    dispatch
  }: { showClosestFirst: boolean } & DispatchProp) => {
    const toggleShowClosestFirst = () =>
      dispatch(setShowClosestFirst(!showClosestFirst));
    return (
      <div className="text-light">
        <Button
          className="btn m-2"
          outline={!showClosestFirst}
          onClick={toggleShowClosestFirst}
        >
          Closest Restaurant First
        </Button>
      </div>
    );
  }
);

function mapStateToProps(state: AppState) {
  return {
    showClosestFirst: showClosestFirstSelector(state)
  };
}
